import React, { useMemo } from 'react'
import { Link, graphql } from 'gatsby'
import Helmet from 'react-helmet'

import Layout from '../components/Layout'
import SEO from '../components/SEO'

import { getSimplifiedPosts } from '../utils/helpers'
import config from '../utils/config'
import python from '../../content/images/python.svg'
import javascript from '../../content/images/javascript.svg'


export default function BlogIndex({ data }) {
  const latest = data.latest.edges
  const popular = data.popular.edges
  const simplifiedLatest = useMemo(() => getSimplifiedPosts(latest), [latest])
  const simplifiedPopular = useMemo(() => getSimplifiedPosts(popular), [
    popular,
  ])

  const Section = ({ title, children, ...props }) => (
    <section {...props}>
      <h2>{title}</h2>
      {children}
    </section>
  )

  return (
    <Layout>
      <Helmet title={config.siteTitle} />
      <SEO />
      <h3>
        Find code snippets, notes, tips and tricks for programming languages, libraries and frameworks.
      </h3>
      <section className="flex flex-col items-start">
        <Link to="/python/" className="mt-10 flex items-center space-x-4" >
          <img src={python} width="48" height="auto" alt="Python"/>
          <div>
            <h5 className="banner-body"> Python Notes</h5>
          </div>
        </Link>

        <Link to="/javascript/" className="mt-10 flex items-center space-x-4" >
          <img src={javascript} width="48" height="auto" alt="JavaScript"/>
          <div>
            <h5 className="banner-body"> JavaScript Notes</h5>
          </div>
        </Link>
      </section>
    </Layout>
  )
}

export const pageQuery = graphql`
  query IndexQuery {
    latest: allMarkdownRemark(
      limit: 5
      sort: { fields: [frontmatter___date], order: DESC }
      filter: { frontmatter: { template: { eq: "post" } } }
    ) {
      edges {
        node {
          id
          fields {
            slug
          }
          frontmatter {
            date(formatString: "MMMM DD, YYYY")
            title
            tags
          }
        }
      }
    }
    popular: allMarkdownRemark(
      limit: 20
      sort: { fields: [frontmatter___date], order: DESC }
      filter: { frontmatter: { categories: { eq: "Popular" } } }
    ) {
      edges {
        node {
          id
          fields {
            slug
          }
          frontmatter {
            date(formatString: "MMMM DD, YYYY")
            title
            tags
          }
        }
      }
    }
  }
`
